export const MediaRoute = {
  Gallery: 'gallery'
} as const;

export type MediaRoute = (typeof MediaRoute)[keyof typeof MediaRoute];

export type MediaRouteParam = {
  [MediaRoute.Gallery]: { position?: number; mediaUrls?: string[] } | undefined;
};
